import axios from "axios"; // or your API wrapper
import { getPaymentData } from "../../Services/MainServices";
export const GET_PAYMENT_HISTORY_REQUEST = "GET_PAYMENT_HISTORY_REQUEST";
export const GET_PAYMENT_HISTORY_SUCCESS = "GET_PAYMENT_HISTORY_SUCCESS";
export const GET_PAYMENT_HISTORY_FAILURE = "GET_PAYMENT_HISTORY_FAILURE";

export const getPaymentHistory = (payload) => async (dispatch) => {
  dispatch({ type: GET_PAYMENT_HISTORY_REQUEST });

  try {
    const response = await getPaymentData(payload); // update API endpoint as needed
    // console.log("=-=-=-=-=-=-=-", JSON.stringify(response, null, 12));
    dispatch({
      type: GET_PAYMENT_HISTORY_SUCCESS,
      payload: response.data?.data,
    });
  } catch (error) {
    dispatch({
      type: GET_PAYMENT_HISTORY_FAILURE,
      payload: error.message || "Failed to fetch payment history",
    });
  }
};
